(ns practitest.frontend.kanban
  (:require [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [ajax.core :as ajax]))

;; TODO: send from backend ?
(def kanban-field
  {:custom?                false
   :system?                true
   ;; TODO: id ? - do we really need it ?
   ;:id                     99
   :label                  "Add to Task Board"
   :name                   :kanban_lane
   :type                   :kanban_lane})

(defn find-lane [value possible-values]
  (first (filter #(= (:id %) (:lane_id value)) possible-values)))

;; re-frame wiring

;; Lane fetch
(defn got-lanes [db [_ lanes]]
  (assoc-in db [:kanban :lanes] lanes))

(re-frame/reg-event-db
  ::got-lanes
  got-lanes)

(defn fetch-lanes [{db :db} _]
  {:http-xhrio
   {:method          :get
    :uri             (broutes/get-url "kanban#lanes" {:p_id (subs/get-current-project-id db)})
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success      [::got-lanes]
    :on-failure      [:practitest.frontend.events/api-error ::fetch-lanes {}]}})

(re-frame/reg-event-fx
  ::fetch-lanes
  fetch-lanes)

;; Subscriptions

;; TODO: project-id
(re-frame/reg-sub
  ::state
  (fn [db _]
    (:kanban db)))

;[:kanban :lanes]
(re-frame/reg-sub
  ::lanes
  (fn [_]
    (re-frame/subscribe [::state]))
  (fn [kanban _]
    (:lanes kanban)))
